// T12 (spec §4.4, decision D7) — the ONE place the platform decides which
// currency an organization keeps its books in.
//
// An organization's `defaultCurrency` is set ONCE, at creation, from the
// country of the address that arrives in the same request, and is changed
// afterwards only by hand in organization settings. Three markets have a
// currency of their own; every other country is served in EUR, which is also
// what an organization with no address at all gets (a solo trainer may omit
// the country — `TrainerOnboardingAddressValidationDto.country` is optional).
//
// The mapping is deliberately a pure function over a plain string rather than
// over `CountriesEnum`: it is also asked about historical values that never
// became ISO-2 (`20260910120300-normalize-address-country-iso.js` warns about
// leftovers, it does not enforce them), and those must map to EUR instead of
// throwing. The backfill migration restates the same four-way decision in SQL
// because a migration is a frozen historical statement; no other caller may
// re-implement it.
import { Currency } from '../enums/payments';

const CURRENCY_BY_COUNTRY: Readonly<Record<string, Currency>> = {
  BA: Currency.BAM,
  RS: Currency.RSD,
  US: Currency.USD,
};

/**
 * The default currency for an organization whose business address is in
 * `country` (ISO-2, case- and whitespace-insensitive). Anything unmapped,
 * empty, `null` or absent is EUR.
 */
export function defaultCurrencyForCountry(country?: null | string): Currency {
  const key = (country ?? '').trim().toUpperCase();
  return CURRENCY_BY_COUNTRY[key] ?? Currency.EUR;
}
